import { Component } from 'react'
import intl from "react-intl-universal"
import { connect } from 'react-redux'
// import { initLanguage } from './actions'
import ch from './locales/zh-CN.json'
import en from './locales/en-US.json'

class Universal extends Component {
  state = { initDone: false }
  render() {
    return (
      this.state.initDone && 
      this.props.children
    )
  }
  loadLocales() {
    const currentLocale = this.props.language
    intl.init({
      currentLocale,
      locales: {
        [currentLocale]: currentLocale.indexOf('zh') > -1 ? ch : en
      }
    })
    .then(() => {
      this.setState({ initDone: true });
    })
  }
  componentDidMount() {
    this.loadLocales()
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.universal.lang,
  }
}

export default connect(mapStateToProps, {})(Universal)



// WEBPACK FOOTER //
// ./src/universal/Universal.js